import React from 'react';
import { ListGroupItem } from 'reactstrap';

import RichText from '../Common/RichText/RichText';
import ImageExpand from './ImageExpand';

class MCAnswer extends React.Component {
  constructor(props) {
    super(props);
    this.doCheckAnswer = this.doCheckAnswer.bind(this);
    this.state = {
      correct: this.props.answer.correct,
      clicked: this.props.clicked,
    };
  }

  renderSymbols = (text) => {
    const isNewQuestion = /<\/?[a-z][\s\S]*>/i.test(text);
    let result = text;
    result = result.replace(/<\/p><p>/g, '<br>');
    result = result.replace(/<p>/, '');
    result = result.replace(/<\/p>/, '');
    if (!isNewQuestion) {
      result = result.replace(/</g, '&lt;');
      result = result.replace(/>/g, '&gt;');
    }
    return result;
  };

  // creates the links that appear in the left menu / Sidebar
  doCheckAnswer(e) {
    if (!this.props.graded) {
      this.setState({ clicked: true });
      this.props.doAnswer(this.props.answer.id);
    }
  }

  render() {
    let badge = '';
    let listClasses = 'd-flex flex-row justify-content-between';

    const answeredCorrect = (
      <div className="solution d-flex flex-row align-items-center">
        <em>Correct</em> Answer <i className="ml-1 success icon-check2" />
      </div>
    );
    const answeredWrong = (
      <div className="solution d-flex flex-row align-items-center">
        <em>Your Answer</em> <i className="ml-1 danger icon-close" />
      </div>
    );
    const answeredWrongHelper = (
      <div className="solution d-flex flex-row align-items-center">
        <em>Correct Answer</em> <i className="ml-1 success icon-check2" />
      </div>
    );

    if (this.props.answered === this.props.answer.id) {
      listClasses += ' selected';
    }

    if (this.props.graded) {
      if (this.props.answered === this.props.answer.id) {
        listClasses += ' selected';
        if (this.state.correct) {
          badge = answeredCorrect;
        } else {
          badge = answeredWrong;
        }
      }

      if (this.props.answered && this.props.answer.correct) {
        badge = answeredWrongHelper;
      }
    }

    return (
      <ListGroupItem
        onClick={this.doCheckAnswer}
        className={listClasses}
        data-test={`answer-button-${this.props.questionNumber}-${
          this.props.index + 1
        }`}
      >
        <div>
          <b className="ml-2 mr-3">{this.props.char}.</b>{' '}
          <RichText
            tag="span"
            className="questions-p"
            html={this.renderSymbols(this.props.text || '')}
          />
          <div
            onClick={(e) => e.stopPropagation()}
            className="smallerImage mt-2"
          >
            <ImageExpand
              imageUrl={this.props.answer.imageUrl}
              className="expanded-image-modal-exam"
            />
          </div>
        </div>
        {badge}
      </ListGroupItem>
    );
  }
}

export default MCAnswer;
